<div class="row no-gutters">
    <div class="col-12 offset-lg-1 col-lg-11">

        <div class="row">
            <div class="col-12">
                <h2 class="title">{{title}}</h2>
            </div>
        </div>

        <app-spacer [bottom]="32"></app-spacer>

        <app-signup-unified-person-complementary-general [userRole]="role"
            *ngIf="stepSlug === 'complementaryGeneral'">
        </app-signup-unified-person-complementary-general>

        <app-signup-unified-person-complementary-address
            *ngIf="stepSlug === 'complementaryAddress'">
        </app-signup-unified-person-complementary-address>

        <app-signup-unified-person-complementary-bank [userRole]="role"
            *ngIf="stepSlug === 'complementaryBank'">
        </app-signup-unified-person-complementary-bank>

        <app-signup-unified-person-complementary-professional
            *ngIf="stepSlug === 'complementaryProfessional'">
        </app-signup-unified-person-complementary-professional>

        <app-signup-unified-person-complementary-bond
            *ngIf="stepSlug === 'complementaryBond'">
        </app-signup-unified-person-complementary-bond>

        <app-signup-unified-person-complementary-risk
            *ngIf="stepSlug === 'complementaryRisk'">
        </app-signup-unified-person-complementary-risk>

        <app-signup-unified-person-complementary-representatives
            *ngIf="stepSlug === 'complementaryRepresentatives'">
        </app-signup-unified-person-complementary-representatives>
    </div>
</div>